import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { palette, theme as colorTheme } from "../Convoze.theme";


const Loader = () => {

  const quotes = [
    "Every call tells a story - Processing it right means understanding the customer behind the voice.",
    "Call processing isn’t just about connection —it’s about clarity, speed, and seamless communication.",
    "A well-processed call is like a smooth conversation —no delays, no drops, just pure understanding.",
    "Behind every successful interaction lies efficient call processing —the silent engine of customer experience.",
    "Call processing turns chaos into communication —organizing signals, data, and intent into meaningful results."
  ];

  const [currentQuote, setCurrentQuote] = useState("");

  useEffect(() => {
    // Shuffle quotes periodically every 3 seconds
    const pickRandomQuote = () => {
      const randomIndex = Math.floor(Math.random() * quotes.length);
      setCurrentQuote(quotes[randomIndex]);
    };

    pickRandomQuote(); // Show one immediately
    const interval = setInterval(pickRandomQuote, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: 500,
      }}
    >
      <Box
        sx={{
          width: "44px",
          height: "44px",
          animation: "spinner-animation 2s infinite ease",
          transformStyle: "preserve-3d",
          position: "relative",
          "@keyframes spinner-animation": {
            "0%": {
              transform: "rotate(45deg) rotateX(-25deg) rotateY(25deg)",
            },
            "50%": {
              transform: "rotate(45deg) rotateX(-385deg) rotateY(25deg)",
            },
            "100%": {
              transform: "rotate(45deg) rotateX(-385deg) rotateY(385deg)",
            },
          },
        }}
      >
        {[...Array(6)].map((_, index) => (
          <Box
            key={index}
            sx={{
              backgroundColor: "#F4EFFC",
              height: "100%",
              position: "absolute",
              width: "100%",
              // border: "2px solid #6366F1",
              border: `2px solid ${colorTheme('palette', 'primary').value}`,
              transform: [
                "translateZ(-22px) rotateY(180deg)",
                "rotateY(-270deg) translateX(50%)",
                "rotateY(270deg) translateX(-50%)",
                "rotateX(90deg) translateY(-50%)",
                "rotateX(-90deg) translateY(50%)",
                "translateZ(22px)",
              ][index],
              transformOrigin: [
                "initial",
                "top right",
                "center left",
                "top center",
                "bottom center",
                "initial",
              ][index],
            }}
          />
        ))}
      </Box>
      {/* Quote below loader */}
      <Typography
        variant="body1"
        sx={{
          mt: 5,
          color: "#555",
          textAlign: "center",
          fontStyle: "italic",
          maxWidth: 600,
        }}
      >
        {currentQuote}
      </Typography>

    </Box>
  );
};

export default Loader;


// import React, { useEffect, useState } from "react";
// import { Box, Typography, keyframes } from "@mui/material";

// // Animation for "Fireworks" bursting
// const burst = keyframes`
//   0% { transform: scale(0); opacity: 1; }
//   50% { opacity: 1; }
//   100% { transform: scale(1.5); opacity: 0; }
// `;

// // Animation for falling confetti
// const confettiFall = keyframes`
//   0% { transform: translateY(-20px) rotate(0deg); opacity: 1; }
//   100% { transform: translateY(500px) rotate(720deg); opacity: 0; }
// `;

// const Loader = () => {
//   const newYearQuotes = [
//     "2026: A New Chapter of Innovation Begins.",
//     "Connecting the World, One Conversation at a Time in 2026.",
//     "May your 2026 be as clear as a perfect connection.",
//     "Elevating Customer Experience to New Heights this Year.",
//     "Cheers to 2026—Where Technology Meets Human Touch."
//   ];

//   const [currentQuote, setCurrentQuote] = useState("");

//   useEffect(() => {
//     const pickRandomQuote = () => {
//       const randomIndex = Math.floor(Math.random() * newYearQuotes.length);
//       setCurrentQuote(newYearQuotes[randomIndex]);
//     };
//     pickRandomQuote();
//     const interval = setInterval(pickRandomQuote, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "80vh",
//         backgroundColor: "#FFFFFF",
//         // position: "relative",
//         // borderRadius: "24px",
//         // overflow: "hidden",
//         // border: "1px solid #F0F0F0"
//       }}
//     >
//       {/* --- FIREWORKS ANIMATION --- */}
//       {[...Array(5)].map((_, i) => (
//         <Box
//           key={`firework-${i}`}
//           sx={{
//             position: "absolute",
//             width: "100px",
//             height: "100px",
//             border: `2px dotted ${i % 2 === 0 ? "#FFD700" : "#6366F1"}`,
//             borderRadius: "50%",
//             top: `${Math.random() * 60}%`,
//             left: `${Math.random() * 80}%`,
//             animation: `${burst} 2s infinite ${i * 0.5}s ease-out`,
//             opacity: 0,
//           }}
//         />
//       ))}

//       {/* --- CONFETTI ANIMATION --- */}
//       {[...Array(15)].map((_, i) => (
//         <Box
//           key={`confetti-${i}`}
//           sx={{
//             position: "absolute",
//             width: "8px",
//             height: "12px",
//             backgroundColor: ["#FFD700", "#6366F1", "#FF69B4", "#00CED1"][i % 4],
//             top: "-10px",
//             left: `${Math.random() * 100}%`,
//             animation: `${confettiFall} ${3 + Math.random() * 2}s infinite linear`,
//             borderRadius: "2px",
//           }}
//         />
//       ))}

//       {/* --- 3D ROTATING CUBE --- */}
//       <Box
//         sx={{
//           width: "56px",
//           height: "56px",
//           animation: "spinner-animation 3s infinite ease-in-out",
//           transformStyle: "preserve-3d",
//           position: "relative",
//           zIndex: 2,
//           "@keyframes spinner-animation": {
//             "0%": { transform: "rotate(45deg) rotateX(-25deg) rotateY(25deg)" },
//             "50%": { transform: "rotate(45deg) rotateX(-385deg) rotateY(25deg) scale(1.1)" },
//             "100%": { transform: "rotate(45deg) rotateX(-385deg) rotateY(385deg) scale(1)" },
//           },
//         }}
//       >
//         {[...Array(6)].map((_, index) => (
//           <Box
//             key={index}
//             sx={{
//               backgroundColor: "rgba(255, 255, 255, 0.95)",
//               height: "100%",
//               position: "absolute",
//               width: "100%",
//               border: `3px solid #FFD700`,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#B8860B",
//               fontWeight: 800,
//               fontSize: "14px",
//               boxShadow: "0 0 15px rgba(255, 215, 0, 0.3)",
//               transform: [
//                 "translateZ(-28px) rotateY(180deg)",
//                 "rotateY(-270deg) translateX(50%)",
//                 "rotateY(270deg) translateX(-50%)",
//                 "rotateX(90deg) translateY(-50%)",
//                 "rotateX(-90deg) translateY(50%)",
//                 "translateZ(28px)",
//               ][index],
//               transformOrigin: [
//                 "initial", "top right", "center left", "top center", "bottom center", "initial",
//               ][index],
//             }}
//           >
//             2026
//           </Box>
//         ))}
//       </Box>

//       {/* --- 2026 QUOTES --- */}
//       <Typography
//         variant="h6"
//         sx={{
//           mt: 8,
//           color: "#444",
//           textAlign: "center",
//           px: 4,
//           fontWeight: 600,
//           minHeight: "60px",
//           zIndex: 2,
//           textShadow: "0 2px 4px rgba(0,0,0,0.05)"
//         }}
//       >
//         {currentQuote}
//       </Typography>

//       <Typography
//         sx={{
//           mt: 2,
//           fontSize: "0.8rem",
//           letterSpacing: 4,
//           color: "#FFD700",
//           fontWeight: 800,
//           textTransform: "uppercase",
//           zIndex: 2,
//           backgroundColor: "rgba(255,255,255,0.7)",
//           px: 2,
//           borderRadius: "10px"
//         }}
//       >
//         Welcome to 2026
//       </Typography>
//     </Box>
//   );
// };

// export default Loader;
